// Default site content used as initial state while /api/content is loading.
// Mirrors the structure of the backend DEFAULT_CONTENT exactly.

import { SITE, NAV_LINKS, ASSETS, PROJECTS, STANDARDS, STANDARD_QUOTE, PRICING_FACTORS } from "@/data/site";

export const DEFAULT_CONTENT = {
  site: SITE,
  nav: NAV_LINKS,
  assets: ASSETS,
  hero: {
    labelLine: "Mažoji architektūra · {city}",
    headlineTop: "Mažoji architektūra",
    headlineBottom: "gyvenimui ir poilsiui.",
    ctaPrimary: { label: "Peržiūrėti projektus", to: "/projektai" },
    ctaSecondary: { label: "Susisiekti", to: "/kontaktai" },
  },
  about: {
    headline: "Nuo meno iki tikrų erdvių.",
    paragraphs: [
      "Piešiu nuo vaikystės ir visada siekiau kurti daiktus, kurie būtų ne tik gražūs, bet ir prasmingi.",
      "Laikui bėgant tai peraugo į architektūrą ir interjero dizainą. Tačiau vien projektuoti man niekada nepakako. Norėjosi suprasti, kaip erdvė gimsta realybėje – kaip ji statoma, kaip veikia medžiagos, detalės ir konstrukcijos.",
      "Per daugelį metų nuėjau kelią nuo pirmojo savo buto remonto iki šeimos namo įrengimo, terasos, stoginės ir nuosavos pirties statybos.",
      "Šiandien kuriu mažosios architektūros objektus, sujungdamas meninį jautrumą ir praktinę statybų patirtį.",
    ],
    blockquote:
      "Grožiui nereikia būti sudėtingam ar prabangiam. Kartais jis gimsta iš apgalvotų proporcijų, kruopščiai apžiūrėtų detalių ir pagarbos tam, kaip žmonės realiai gyvena erdvėje.",
    stats: [
      { n: "12+", label: "Metai piešiu" },
      { n: "3", label: "Pirčių modeliai" },
      { n: "1:1", label: "Asmeninis dalyvavimas" },
    ],
  },
  projects: PROJECTS,
  standards: STANDARDS,
  standardQuote: STANDARD_QUOTE,
  pricingFactors: PRICING_FACTORS,
  pricingIntro: {
    headline: "Kiekviena pirtis – individuali.",
    body: [
      "Kiekviena pirtis prasideda nuo aiškios architektūrinės idėjos ir bazinės komplektacijos. Tačiau galutinė projekto kaina visuomet formuojama individualiai – pagal jūsų poreikius, pasirinktus sprendimus ir sklypo ypatumus.",
      "Vieniems svarbiausia praktiškumas ir racionalūs sprendimai. Kitiems – panoraminiai aliuminio langai, natūralios medžiagos ir išskirtinė atmosfera. Todėl kiekvieną projektą galima pritaikyti individualiai, išlaikant pagrindinę architektūrinę idėją ir estetinį vientisumą.",
    ],
  },
  seo: {},
};
